import { render, staticRenderFns } from "./LastUpdatedDraft.vue?vue&type=template&id=6f3f80ba&"
import script from "./LastUpdatedDraft.vue?vue&type=script&lang=js&"
export * from "./LastUpdatedDraft.vue?vue&type=script&lang=js&"
import style0 from "./LastUpdatedDraft.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports